import { useCallback, useEffect, useRef, useState } from "react";

import { fetchPayoutAccounts } from "../http/stripeLinks";

// The Stripe accounts the signed-in owner's events already pay out to, from
// evt.live (the shape is in components/http/stripeLinks.js). Only for the
// account holder of a business account: callers pass enabled: false
// otherwise, and nothing is fetched.
export default function usePayoutAccounts({ enabled }) {
  const [state, setState] = useState({ ready: false, data: null, error: null });
  const mounted = useRef(true);
  useEffect(
    () => () => {
      mounted.current = false;
    },
    []
  );

  const reload = useCallback(async () => {
    if (!enabled) return null;
    try {
      const data = await fetchPayoutAccounts();
      if (mounted.current) setState({ ready: true, data, error: null });
      return data;
    } catch (error) {
      if (mounted.current) setState({ ready: true, data: null, error });
      return null;
    }
  }, [enabled]);

  useEffect(() => {
    if (enabled) reload();
  }, [enabled, reload]);

  return { ...state, enabled: !!enabled, reload };
}
